import React from 'react';
import Layout from '../components/layout/Layout';
import SEO from '../components/SEO';
import ContactIcon from '../svg/contact.svg';
import { navigate } from 'gatsby-link';

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}
export default class Index extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isValidated: false }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleRecaptcha = value => {
    this.setState({ "g-recaptcha-response": value });
  };
  handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form.getAttribute('name'),
        ...this.state,
      }),
    })
      .then(() => navigate(form.getAttribute('action')))
      .catch((error) => alert(error))
  }

  render() {
    return (
      <Layout>
        <SEO title="¡Contáctanos!" />
        <div
          className="max-w-screen-xl mt-10 px-8 grid gap-8 grid-cols-1 md:grid-cols-2 md:px-12 lg:px-16 xl:px-32 py-16 mx-auto bg-gray-200 text-gray-900 rounded-lg shadow-lg">
          <div className="flex flex-col justify-between">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold leading-tight">¡Contacto con nosotros!</h2>
              <div className="text-gray-700 mt-8">
                Un asesor te explicará todo personalmente <strong>
                Gratis!!
              </strong>
                <br />
                <strong>
                  LLama: &nbsp;
                </strong>
                <span>Ec 0995430270</span>
                <br />
                <strong>
                  Correo: &nbsp;
                </strong>
                <span>info@tnsconvenios.com</span>
                <br />
                <strong>
                  Correo: &nbsp;
                </strong>
                <span>info.agencciaac@gmail.com</span>
                <p className="mt-8">
                  <a className="inline-flex items-center h-8 px-4 m-2 text-sm text-indigo-100 transition-colors duration-150 bg-green-500 rounded-lg focus:shadow-outline hover:bg-green-800"
                     href="https://wa.link/3djtii">
                    Whatsapp Empresarial
                  </a>
                </p>
              </div>
            </div>
            <div className="mt-8 text-center">
              <ContactIcon/>
            </div>
          </div>
          <form
            name="contact"
            method="post"
            action="/thanks"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={this.handleSubmit}
          >
            <input type="hidden" name="form-name" value="contact"/>
            <div hidden>
              <label>
                No llene esto :{' '}
                <input name="bot-field" onChange={this.handleChange} />
              </label>
            </div>
            <div className="">
              <div>
                <span className="uppercase text-sm text-gray-600 font-bold">Nombre Completo</span>
                <input
                  className="w-full bg-gray-300 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                  type={'text'}
                  name={'name'}
                  onChange={this.handleChange}
                  id={'name'}
                  placeholder="Carlos Andrade"/>
              </div>
              <div className="mt-8">
                <span className="uppercase text-sm text-gray-600 font-bold">Correo</span>
                <input
                  className="w-full bg-gray-300 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                  type={'email'}
                  name={'email'}
                  onChange={this.handleChange}
                  id={'email'}
                  required={true}
                  placeholder="ejemplo@email.com"/>
              </div>
              <div className="mt-8">
                <span className="uppercase text-sm text-gray-600 font-bold">Mensaje</span>
                <textarea
                  className='w-full h-32 bg-gray-300 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline'
                  name={'message'}
                  onChange={this.handleChange}
                  id={'message'}
                  required={true}
                  placeholder="Revise tus web y necesito mas información de tus servicios"
                />
              </div>
              <div className="mt-8">
                <button
                  type="submit"
                  onSubmit="validate"
                  className="uppercase text-sm font-bold tracking-wide bg-teal-400 text-gray-100 p-3 rounded-lg w-full focus:outline-none focus:shadow-outline">
                  Enviar
                </button>
              </div>
            </div>
          </form>
        </div>
      </Layout>
    )
  }
}